module.exports = "images/pdf.png";